import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GlobalPerformanceLogger } from '../performanceLoggerGlobal';

@Injectable()
export class PerformanceMonitorInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Ignora arquivos de assets
    if (!req.url.startsWith('./assets')) {
      // 🔹 Recupera dados da sessão
      let tela = sessionStorage.getItem('idTela');
      if (!tela) {
        tela = 'SEL041';
        sessionStorage.setItem('idTela', tela);
      }
      const cdUsuario = sessionStorage.getItem('cdUsuario') ?? '';

      // 🔹 Clona a requisição adicionando headers
      const authReq = req.clone({
        headers: req.headers
          .set('tela_id', tela)
          .set('tela', 'SEL041')
          .set('user', cdUsuario),
      });

      const start = performance.now();

      return next.handle(authReq).pipe(
        tap({
          next: (event) => {
            if (event instanceof HttpResponse) {
              const tempo = performance.now() - start;

              // ✅ Verificação segura do body e suas propriedades
              const operationType = authReq.body?.operationType || 'UNKNOWN';
              const operationName = authReq.body?.name || '';

              console.log(
                `%c🟢 [HTTP] ${operationType} ${
                  operationType === 'SELECT_FULL' ? '' : operationName
                } - ${tempo.toFixed(1)}ms`,
                'color: #6cbbd8ff; font-weight: bold;'
              );

              GlobalPerformanceLogger.registerHttpRequest(
                authReq,
                tempo,
                false
              );
            }
          },
          error: (error: HttpErrorResponse) => {
            const tempo = performance.now() - start;

            // ✅ Verificação segura do body e suas propriedades
            const operationType = authReq.body?.operationType || 'UNKNOWN';
            const operationName = authReq.body?.name || '';

            console.groupCollapsed(
              `%c🔴 [HTTP] ${operationType} ${operationName} - ${tempo.toFixed(1)}ms`,
              'color: #6cbbd8ff; font-weight: bold;'
            );
            console.error(error);
            console.groupEnd();

            GlobalPerformanceLogger.registerHttpRequest(authReq, tempo, true);
          },
        })
      );
    }

    // Requisição de asset, passa direto
    return next.handle(req);
  }
}
